'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var chunk = exports.chunk = require('lodash.chunk');
var difference = exports.difference = require('lodash.difference');
var differenceBy = exports.differenceBy = require('lodash.differenceby');
var findIndex = exports.findIndex = require('lodash.findindex');var flatten = exports.flatten = require('lodash.flatten');
var head = exports.head = require('lodash.head');
var last = exports.last = require('lodash.last');

var first = exports.first = head;

var _unique = require('lodash.uniq');
var _uniqueBy = require('lodash.uniqby');
var _uniqueBySorted = require('lodash.sorteduniqby');
var _uniqueSorted = require('lodash.sorteduniq');

var unique = exports.unique = function unique(array) {
  var sorted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return sorted === true ? _uniqueSorted(array) : _unique(array);
};

var uniqueBy = exports.uniqueBy = function uniqueBy(array, iteratee) {
  var sorted = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return sorted === true ? _uniqueBySorted(array, iteratee) : _uniqueBy(array, iteratee);
};

exports.default = {
  chunk: chunk,
  difference: difference,
  differenceBy: differenceBy,
  findIndex: findIndex,
  first: first,
  flatten: flatten,
  head: head,
  last: last,
  unique: unique,
  uniqueBy: uniqueBy
};